import { render, staticRenderFns } from "./CambioPrecio.vue?vue&type=template&id=491e5b82&"
import script from "./CambioPrecio.vue?vue&type=script&lang=js&"
export * from "./CambioPrecio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports